import { React, useState, useEffect } from "react";
import styled from "styled-components";
import { Layout, Table, Button, PageHeader } from "antd";
import {
  RightLayoutContainer,
  OtherPages,
  PageTitleComp,
} from "../styledElements";
import logoCompany from "../../Assets/Images/logo.svg";
import Iconmoon from "../../Components/IconsFiles/icon";
import * as htmlToImage from "html-to-image";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { paperMachineListData } from "../../Services/machineServices";
import { getCompanyDetails } from "../../Services/companyServices";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";

const PrintData = styled.div`
  padding: 0px;
  margin: 40px auto;
  background-color: #fff;
  width: 845px;
`;
const ExportHeader = styled.div`
  background-color: #faf9f8;
  padding: 10px 15px;
  .file-header {
    display: flex;
    justify-content: space-between;
  }
  .file-header-logo {
    width: 130px;
    display: flex;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .client-name {
    width: 25%;
  }
  .client-name h4 {
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    margin: 0px;
  }
  .client-name h6 {
    font-style: italic;
    color: #605e5c;
    font-size: 10px;
    margin: 0px;
  }
  .client-data {
    display: flex;
    > div {
      width: 50%;
      label {
        color: #000;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
      span {
        color: #605e5c;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
    }
  }
`;
const ExportTable = styled.div`
  table {
    width: 100%;
  }
  thead th {
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  td {
    border-bottom: 1px solid #000;
  }

  th,
  td {
    text-align: left;
    padding: 5px 5px;
  }
  th {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
    font-family: var(--sf-pro-text);
  }
  p {
    margin: 0;
    font-family: var(--sf-pro-text);
  }
  .order-d {
    p {
      text-transform: uppercase;
      font-size: 7px;
      font-weight: 600;
    }
    .order-d-l {
      p {
        text-transform: none;
        color: #605e5c;
        font-size: 7px;
        font-weight: 400;
      }
    }
  }
  .date {
    color: #000;
    font-size: 8px;
    font-weight: 600;
  }
  .p-detail {
    font-size: 7px;
    font-weight: 600;
    color: #605e5c;
  }
  .factor {
    color: #000;
    font-size: 7px;
    font-weight: 600;
    font-style: italic;
  }
  .p-ton {
    font-size: 8px;
    font-weight: 600;
    color: #000;
  }
  .reel {
    font-size: 8px;
    color: #605e5c;
    font-style: italic;
  }
  .remark {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 90px;
    line-height: 1.2;
  }
  .address {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 170px;
    line-height: 1.2;
  }
  .ms-2 {
    width: 50px;
  }
  .f-10 {
    font-size: 10px !important;
  }
  .disabled {
    background: #f3f2f1;
  }
`;

function addScript(url) {
  const script = document.createElement("script");
  script.type = "application/javascript";
  script.src = url;
  document.head.appendChild(script);
}
addScript(
  "https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js"
);

const ExportMachinePdf = (props) => {
  const location = useLocation();
  const [showLoader, setLoader] = useState(false);
  const [machineRecords, setMachineRecords] = useState(location?.state?.machineRecords);
  const [fileNameForPDF, setFileNameForPDF] = useState(location?.state?.fileNameForPDF);
  const [company, setCompany] = useState();
  const navigate = useNavigate();
  const currentDate = new Date();
  const today = (currentDate.getDate() + " " + currentDate.toLocaleString("default", { month: "long" }) + "," +  currentDate.getFullYear());

  useEffect(() => {
    setCompanyDetails();
  }, []);

  const setCompanyDetails = () => {
    getCompanyDetails()
      .then((response) => {
        setCompany(response.data);
      })
      .catch((error) => console.log("Error", error));
  };

  const exportHandler = () => {
    const input = document.getElementById("export-content");
    html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
      (canvas) => {
        const image = { type: "jpeg", quality: 0.98 };
        const margin = [0.5, 0.5];
        const filename = "myfile.pdf";

        var imgWidth = 8.5;
        var pageHeight = 11;

        var innerPageWidth = imgWidth - margin[0] * 2;
        var innerPageHeight = pageHeight - margin[1] * 2;

        // Calculate the number of pages.
        var pxFullHeight = canvas.height;
        var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
        var nPages = Math.ceil(pxFullHeight / pxPageHeight);

        // Define pageHeight separately so it can be trimmed on the final page.
        var pageHeight = innerPageHeight;

        // Create a one-page canvas to split up the full image.
        var pageCanvas = document.createElement("canvas");
        var pageCtx = pageCanvas.getContext("2d");
        pageCanvas.width = canvas.width;
        pageCanvas.height = pxPageHeight;

        // Initialize the PDF.
        var pdf = new jsPDF("p", "in", [8.5, 11]);

        for (var page = 0; page < nPages; page++) {
          // Trim the final page to reduce file size.
          if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
            pageCanvas.height = pxFullHeight % pxPageHeight;
            pageHeight =
              (pageCanvas.height * innerPageWidth) / pageCanvas.width;
          }

          // Display the page.
          var w = pageCanvas.width;
          var h = pageCanvas.height;
          pageCtx.fillStyle = "white";
          pageCtx.fillRect(0, 0, w, h);
          pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

          // Add the page to the PDF.
          if (page > 0) pdf.addPage();
          debugger;
          var imgData = pageCanvas.toDataURL(
            "image/" + image.type,
            image.quality
          );
          pdf.addImage(
            imgData,
            image.type,
            margin[1],
            margin[0],
            innerPageWidth,
            pageHeight
          );
        }

        pdf.save(fileNameForPDF+".pdf");
      }
    );
  };
  return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() =>
            navigate("../machine-records/export-machine", {
            state: {
              body: location?.state?.body,
              rootPage: location?.state?.rootPage,
              fileName: fileNameForPDF,
              machineRecords: machineRecords,
              onBack: true,
            },
          })
        }
          title="Machine Records Preview"
          extra={[
            <Button
              key="1"
              className="themeBtn"
              onClick={() => exportHandler()}
            >
              <Iconmoon icon="download" size={17} color="#FFFFFF" />
              Download Machine Records
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      {/* <Button onClick={() => exportHandler()} className="themeBtn">Download Machine Records </Button> */}
      <PrintData id="export-content">
        <OtherPages>
          <Layout
            style={{
              backgroundColor: "#ffffff",
            }}
          >
            <div>
              <ExportHeader>
                <div className="file-header">
                  <div className="file-header-logo">
                    <img src={logoCompany} alt="Kaiznn" />
                  </div>
                  <div className="client-name">
                    {company && <h4>{company.business_name} </h4>}
                    <h6>Machine Records</h6>
                    <div className="client-data">
                      <div>
                        <label>Number of records</label>
                        <span>{machineRecords?.length}</span>
                      </div>
                      <div>
                        <label>Date:</label>
                        <span>{today}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </ExportHeader>
              <ExportTable>
                <table>
                  <thead>
                    <tr>
                      <th>MACHINE CODE</th>
                      <th>MACHINE DETAILS</th>
                      <th>GSM RANGE</th>
                      <th>DECKLE WIDTH RANGE</th>
                      {/* <th>DEFAULT EDGE TRIM</th> */}
                      {/* <th>MAXIMUM CUTTERS</th>
                      <th>MAX. ALLOWED TRIM LOSS</th> */}
                      <th>PRDUCTION CAPACITY</th>
                      <th>REMARKS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {machineRecords?.map((machine) => {
                      return (
                        <tr
                          className={
                            machine.status === "Disabled" ? "disabled" : ""
                          }
                        >
                          <td>
                            <p className="p-ton f-10">{machine.code}</p>
                            <p className="reel f-10">{machine.status}</p>
                          </td>
                          <td>
                            <p className="p-detail f-10">{machine.name}</p>
                            <p className="reel f-10">{machine.order_type}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{machine.gsm_range}</p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{machine.width_range}</p>
                          </td>
                          {/* <td>
                            <p className="p-ton f-10">{`Left ${machine.left} CM`}</p>
                            <p className="p-ton f-10">{`Right ${machine.right} CM`}</p>
                            <p className="reel f-10">{`Effective ${machine.effective} CM`}</p>
                          </td> */}
                          {/* <td>
                            <p className="p-ton f-10">
                              {machine.maximum_cutters}
                            </p>
                          </td>
                          <td>
                            <p className="p-ton f-10">{`${machine.wastage} %`}</p>
                          </td> */}
                          <td>
                            <p className="p-ton f-10">{`${machine.production_capacity}`}</p>
                          </td>
                          <td>
                            <p className="remark f-10">{machine.remarks}</p>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </ExportTable>
            </div>
          </Layout>
        </OtherPages>
      </PrintData>
    </RightLayoutContainer>
  );
};
export default ExportMachinePdf;
